import type {
    ActiveRoleAssignmentResponse,
    GetProfileRequestOptions,
    ImpersonationContextResponse,
    SessionUserProfileDetailedResponse,
} from '@pillar-portal/api-types';
import { authApi } from '@/lib/pillarApi';
import {
    runSessionSensitiveRequest,
    SessionSensitiveRequestNameConst,
} from '@/lib/sessionSensitiveRequestManager';

export {
    invalidateSessionSensitiveRequests,
    StaleEffectiveSessionResponseError,
} from '@/lib/sessionSensitiveRequestManager';

export const sessionSensitiveAuthApi = {
    getProfile: async (
        options: GetProfileRequestOptions = {}
    ): Promise<SessionUserProfileDetailedResponse> =>
        runSessionSensitiveRequest(
            SessionSensitiveRequestNameConst.profile,
            async () => await authApi.getProfile(options)
        ),

    getActiveRoleAssignment: async (): Promise<ActiveRoleAssignmentResponse | null> =>
        runSessionSensitiveRequest(
            SessionSensitiveRequestNameConst.activeRoleAssignment,
            authApi.getActiveRoleAssignment
        ),

    getImpersonationContext: async (): Promise<ImpersonationContextResponse | null> =>
        runSessionSensitiveRequest(
            SessionSensitiveRequestNameConst.impersonationContext,
            authApi.getImpersonationContext
        ),
};
